export default __webpack_public_path__ + "static/media/RCFC_2021_BEST_1_LS.fd7fe2a9.mp4";